export class InvalidInputError extends Error {
    public errors: any[];

    /**
     * @param errors
     * @param params
     */
    constructor(errors: any[], ...params: any) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Custom debugging information
        this.errors = errors;
    }
}
